export const BASE_MNC_EVENT_OPTIONS = Object.freeze([
  { label: "ทั้งหมด", value: undefined },
  { label: 'รับ coin จำนวน 1% จากราคาบ้าน', value: 'NEW_HOME_COIN_ONE_PERCENT' },
  { label: "เปิดกระเป๋า wallet", value: "CUSTOMER_CREATE_WALLET" },
  { label: "ซื้อของ RJ 1%", value: "BUY_RJ_PACKAGE_ONE_PERCENT" },
  { label: "ซื้อของ RJ 2%", value: "BUY_RJ_PACKAGE_TWO_PERCENT" },
]);
